export default __webpack_public_path__ + "static/media/purple-fancy-house.4e99ef3b.svg";